import './router/componentHooks';
import Vue from 'vue';
import Vant from 'vant';
import { Lazyload } from "vant";
import 'vant/lib/index.css';
import './scss/index.scss';
import wm from '@/utils/wsm.index';
import VConsole from 'vconsole';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations';
import { Integrations } from '@sentry/tracing';
import moment from 'moment';
import websocketMessageModule from './utils/websocketMessage';
import { nav, NoData } from './components';
import App from './App.vue';
import router from './router';
import store from './store';
import VueTouch from 'vue-touch';
import BaiduMap from 'vue-baidu-map';
import {getUrlQuery,makeIcon,getSchoolConfig,isCourseAuth} from '@/utils/utils';
import loginApi from '@/apis/login/login';
import urlConfig from '@/Configurations/urlConfig';
import VueLazyload from 'vue-lazyload'
const { version } = require('../package.json');
import infiniteScroll from 'vue-infinite-scroll';
import VueClipboard from 'vue-clipboard2'
import {unescape} from '@/utils/utils';
import VueRouterReferer from '@tozd/vue-router-referer';
import i18n from './lang/index';


//import 'amfe-flexible/index.js';
// 生产环境开启sentry的错误日志收集, 非生产环境开启vconsole方便调试
if (process.env.NODE_ENV === 'production') {
  // Sentry.init({
  //   release: `ktpH5${version}`,
  //   dsn: 'https://3286bf0a4dc143298745483021691444@o294988.ingest.sentry.io/5420809',
  //   integrations: [
  //     new VueIntegration({
  //       Vue,
  //       tracing: true,
  //       // @ts-ignore
  //       tracingOptions: { trackComponents: true }
  //     }),
  //     new Integrations.BrowserTracing()
  //   ],
  //   tracesSampleRate: 10
  // });
}

if(process.env.VUE_APP_ENV === 'test') {
  // 测试环境启用
  new VConsole({});
}

//初始化页面
function initVueData(){
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app');
}
//显示最原始的配置
function showOriginConfig(){
  let schoolConfigObj = getSchoolConfig();
  if(schoolConfigObj){
    document.title = schoolConfigObj['schoolName'];
    if(schoolConfigObj['appid'] && schoolConfigObj['appid'].length>0){
      window.localStorage.setItem('appid_cache',schoolConfigObj['appid']);
    }
    makeIcon(schoolConfigObj['ico_url']);
    initVueData();
  }else{
    document.title = urlConfig.appName;
    makeIcon('/favicon.ico');
    initVueData();
  }
}

// 全局注册
Vue.use(VueTouch, { name: 'v-touch' });
Vue.use(Vant);
Vue.use(nav);
Vue.use(NoData);
Vue.use(wm);
Vue.use(VueLazyload);
Vue.use(BaiduMap, {
  ak: 'TVhjYjq1ICT2qqL5LdS8mwas'
})
Vue.use(infiniteScroll);
Vue.use(VueClipboard)
Vue.prototype.$moment = moment;
Vue.prototype.$moment.locale('zh-cn');
Vue.config.productionTip = false;
Vue.use(VueRouterReferer);
Vue.use(Lazyload);

/**
 * 登录弹窗提醒
 */
 Vue.prototype.loginTipsDialog = function() {
   this.$dialog.confirm({
     title: '提示',
     message: '还未登录，是否先登录？',
   }).then(() => {
     sessionStorage.from = location.href;
     location.href = '/login';
   })
}

Vue.prototype.filterElement = function (value: string) {
  if (!value) return ''
  let tmp =  value.replace(/<img (.*?) \/>/gi, '[图片]')
              .replace(/<.*?>/gi, '');

  return unescape(tmp);
}

/**
 * 打开新窗口
 */
Vue.prototype.openNewWindow = function(href: string) {
  location.href = href;
}

//课程功能模块权限鉴定
Vue.prototype.isCourseAuth = function(bindVal:any) {
  return isCourseAuth(bindVal);
}

//忽略标签部分
Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
];

//发现带有此参数
let mobilexdomain = getUrlQuery('mobilexdomain');
let appid = getUrlQuery('appid');
if(mobilexdomain && mobilexdomain.length>0){
  loginApi.getSchoolConfig({school:mobilexdomain}).then((res)=>{
    if(res && res['mobileBanner'] && res['mobileBanner'].length>0){
      res['mobilexdomain'] = mobilexdomain;
      window.localStorage.setItem('schoolConfig',JSON.stringify(res));
      document.title = res['schoolName'];
      if(res['appid'] && res['appid'].length>0){
        window.localStorage.setItem('appid_cache',res['appid']);
      }
      makeIcon(res['ico_url']);
      initVueData();
    }else{
      showOriginConfig();
    }
  });
}else{
  if(appid && appid.length>0){
    loginApi.getSchoolConfig({appid:appid}).then((res)=>{
      if(res){
        window.localStorage.setItem('schoolConfig',JSON.stringify(res));
        document.title = res['schoolName'];
        if(res['appid'] && res['appid'].length>0){
          window.localStorage.setItem('appid_cache',res['appid']);
        }
        makeIcon(res['ico_url']);
        initVueData();
      }else{
        showOriginConfig();
      }
    });
  }else{
    showOriginConfig();
  }
}
console.log(`当前软件版本为:${version}`);
